<script lang="ts">
  import { getStripeSession, getSubscriptionQuery } from './mutations.svelte';
  import { page } from '$app/state';
  import Spinner from '~/components/Spinner.svelte';
  import { PUBLIC_STRIPE_KEY } from '$app/env/public';

  const subscription = getSubscriptionQuery();
  const stripeSession = $derived(getStripeSession(
    !!page.data.user && !subscription.data,
  ));
</script>

{#if stripeSession.isLoading}
  <Spinner />
{:else if stripeSession.isSuccess}
  <div id="#premium">
    <stripe-buy-button
      buy-button-id="buy_btn_1PnBe0EoPDBATc7lubCBY4fD"
      customer-session-client-secret={stripeSession.data.client_secret}
      publishable-key={PUBLIC_STRIPE_KEY}
    >
    </stripe-buy-button>
  </div>
{/if}
